module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-08-df37748ae0abdc3a2936223e59ae1275.jpg";